import { appGlobalSettingsSelector } from "ducks/selectors/appGlobalSettings";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { setGlobalSettingsForFormatter } from "utils/i18nFormatter";

export function useI18nFormatterListener() {
  const globalSettings = useSelector(appGlobalSettingsSelector);

  useEffect(() => {
    if (globalSettings) {
      //console.log({ globalSettings });
      setGlobalSettingsForFormatter(globalSettings);
    }
  }, [globalSettings]);
}
